<template>
    <div>
        <v-server-table ref="designationTable" url="/subcontractors/designations-list" :columns="columns" :options="options">

            <router-link slot="designation_id" slot-scope="props" :to="`/subcontractors/settings/designations/edit/${props.row.designation_id}`" title="Edit Designation" class="btn btn-xs btn-default">
                <i class="fa fa-edit"></i> Edit
            </router-link>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['designation_id', 'designation_name'],
                options: {
                    perPage: 10000,
                    perPageValues: [],
                    columnsDropdown: false,
                    filterable: false,
                    headings: {
                        designation_id: 'Edit',
                        designation_name: 'Designation Name',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'designations.designation_name',
                    },
                    uniqueKey: 'designation_id',
                },
            }
        }
    }
</script>
